import request from "@utils/request";

export default function getToken(params) {
  return request({
    url: "/Aliyun/getToken",
    model: "Tools",
    params,
    ss: 222
  });
}

export function upload(url, data) {
  return request({
    url,
    method: "post",
    headers: {
      ContentType: "multipart/form-data"
    },
    withCredentials: false,
    data
  });
}
